import React from "react";
import { Container, Typography, CardContent, Card } from "@mui/material";

const AboutUs: React.FC = () => {
  return (
    <Container maxWidth="md">
      <Card>
        <CardContent>
          <Typography variant="h5" style={{marginBottom:"30px"}}>About Us</Typography>

          <Typography variant="body1" style={{marginBottom:"30px"}}>Welcome to collecting.cash, a service by Maroulie LLC, where we simplify the process of collecting payments by helping you send timely notifications to your recipients. Our mission is to provide an easy, reliable, and automated way to keep track of recurring payments without the hassle of constant follow-ups.</Typography>

          <Typography variant="body1" style={{marginBottom:"30px"}}>At Maroulie LLC, we understand that managing payments can be time-consuming. That's why we've built a simple yet effective tool that ensures your recipients receive notifications, helping you stay organized and increasing the chances of getting paid on time. While we currently focus on email notifications, we aim to expand our services to include additional communication methods in the future.</Typography>

          <Typography variant="body1" style={{marginBottom:"30px"}}>We are committed to security, privacy, and a seamless user experience. Your data is protected, and we never sell or share your information for marketing purposes. Our goal is to offer a transparent, user-friendly solution that supports individuals, businesses, and organizations in their payment collection needs.</Typography>

          <Typography variant="body1" style={{marginBottom:"50px"}}>Join us and take the stress out of payment tracking with Maroulie LLC's collecting.cash.</Typography>
        </CardContent>
      </Card>
    </Container>
  );
};

export default AboutUs;
